import { render, staticRenderFns } from "./BaseScreenTabFocusView.vue?vue&type=template&id=fbff50b0&scoped=true&"
import script from "./BaseScreenTabFocusView.vue?vue&type=script&lang=js&"
export * from "./BaseScreenTabFocusView.vue?vue&type=script&lang=js&"
import style0 from "./BaseScreenTabFocusView.vue?vue&type=style&index=0&id=fbff50b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbff50b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
